export default "__VITE_ASSET__9d48a28a__"